import apiInfraction from "../axios/apiInfraction";

class FaultService {
  static async getAllFaults() {
    try {
      const response = await apiInfraction.get(`/faults`);
      if (response.status === 200) {
        return { success: true, data: response.data.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching faults:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default FaultService;